import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import configurationsDictionariesReducer from './dictionaries/slice';

// BANK AND PSP
import bankAndPspListReducer from '../hoc/bank-and-psp/store/slices/list';
import bankAndPspItemFormReducer from '../hoc/bank-and-psp/store/slices/item-form';
import bankAndPspInfoReducer from '../hoc/bank-and-psp/store/slices/info';
import bankAndPspInfoAccountReducer from '../hoc/bank-and-psp/store/slices/info-account-form';
import bankAndPspAccountPageReducer from '../hoc/bank-and-psp/store/slices/account';

// TARIFFS
import tariffsListReduer from '../hoc/tariffs/store/slices/list';
import tariffsCreateTariffFormReducer from '../hoc/tariffs/store/slices/create-tariff';
import tariffPageReducer from '../hoc/tariffs/store/slices/tariff-page';
import feeFormReducer from '../hoc/tariffs/store/slices/fee-form';

// FEES
import feesListReducer from '../hoc/fees/store/slices/list';
import feeTypesFormReducer from '../hoc/fees/store/slices/form';

// CARDS
import cardsListReducer from '../hoc/cards/store/slices/list';
import cardItemReducer from '../hoc/cards/store/slices/item';
import transactionItemReducer from '../hoc/cards/store/slices/transaction';

// CURRENCIES
import currenciesListReducer from '../hoc/currencies/store/slices/list';
import currencyFormReducer from '../hoc/currencies/store/slices/form';

// INTEGRATION LOGS
import integrationLogsReducer from '../hoc/integration-logs/store/slice';

// middlewares
import configurationMiddleware from './middlewares';

export const configurationReducers = {
  configurationApi: api.reducer,
  configurationDictionaries: configurationsDictionariesReducer,
  bankAndPsp: combineReducers({
    list: bankAndPspListReducer,
    itemForm: bankAndPspItemFormReducer,
    info: bankAndPspInfoReducer,
    infoAccountForm: bankAndPspInfoAccountReducer,
    accountPage: bankAndPspAccountPageReducer,
  }),
  tariffs: combineReducers({
    list: tariffsListReduer,
    createTariffForm: tariffsCreateTariffFormReducer,
    tariffPage: tariffPageReducer,
    feeForm: feeFormReducer,
  }),
  fees: combineReducers({
    list: feesListReducer,
    form: feeTypesFormReducer,
  }),
  cards: combineReducers({
    list: cardsListReducer,
    item: cardItemReducer,
    transaction: transactionItemReducer,
  }),
  currencies: combineReducers({
    list: currenciesListReducer,
    form: currencyFormReducer,
  }),
  integrationLogs: integrationLogsReducer,
};

export const configurationApi = [
  api.middleware,
  configurationMiddleware.middleware,
];
